import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto'
import { Message } from 'iview'
import store from '@/store'
import Router from '@/router/index'
Vue.prototype.axios = axios

// http://qnbox.fgcq.info/
// https://qn-api.jherow.com
const baseURL = axios.defaults.baseURL = process.env.NODE_ENV === 'development'
? 'https://qn-api.jherow.com/'
: 'https://qn-api.jherow.com/'


//视频上传的地址
const base = 'https://videoupbbs.3975.com/interface/'

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

const MD5 = (value) => {
  return crypto.createHash('md5').update(value).digest('hex')
}
function getCookie(name) {
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}


const sign = (params = {}) => { 
  const keys = Object.keys(params).sort()
  const signs = []
  for (let key of keys) {
    if (params[key] == null) {
      params[key] = ''
    }
    signs.push(`${key}=${encodeURIComponent(params[key])}`)
  }
  return MD5(signs.join('&') + '56221336cd79a1d66a4227c1cb9e36ec')
}

const httpRequest = async (url, file) => {
  let accessToken;
  let refreshToken;
  ({ accessToken, refreshToken } = store.getters.state);
  if (refreshToken && !accessToken) {
    accessToken = await store.dispatch("refreshToken", refreshToken);
  }
  const headers = {
    Authorization: accessToken,
    "Access-Token": refreshToken,
  };
  var params = {
    version: store.getters.state.version,
    bundle_id: store.getters.state.bundle_id,
    plat: store.getters.state.plat,
    udid: store.getters.state.udid,
    time: Date.parse(new Date()) / 1000,
    app_key: store.getters.state.app_key,
  };
  params['sign'] = sign({...params})
  const fd = new FormData();
  fd.append("file", file);
  fd.append("version", params.version);
  fd.append("bundle_id", params.bundle_id);
  fd.append("plat", params.plat);
  fd.append("udid", params.udid);
  fd.append("time", params.time);
  fd.append("app_key", params.app_key);
  fd.append("sign", params.sign);
  return axios.post(baseURL + url, fd, { headers });
};

const http = ({ method = 'GET', url = '', headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest()
  return new Promise((resolve, reject) => {
    xhr.open(method, base + url, true)
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value)
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response))
      } else {
      resolve({msg: xhr.statusText});
      }
    }
    xhr.send(body)
  })
}

const instance = axios.create({
  baseURL,
  timeout: 30000,
  // withCredentials: true,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
  transformRequest: data => qs.stringify(data)
})


// 添加响应拦截器
instance.interceptors.response.use(response => {
  if (response.headers['date']) {
    store.commit('setServiceTime', response.headers.date)
  }
  if (response.status == 200) {
    const data = response.data || {}
  //  if(typeof(data) == 'string') {
  //   data = Decrypt(data)
  //  }
    //console.log(data);
    if (data.code != 200 && response.config.url != 'shop/check-order-pay'&&response.config.url !='game/game-newest-list') {
      store.dispatch('pushError', data.msg)
    }
    // if (data.status >= 4001 && data.status <= 4004) {
    //   store.dispatch('logout', 'replace')
    // }
    // if(data.status == 4000) {
    //   Router.push({ name: 'maintain' })
    // }
    return data
  }
 
  return {}
}, error => {
  if(error.toString() != 'Error: Network Error') {
    store.dispatch('pushError', error.toString())
  }
  return Promise.resolve(error)
})


var appdeviceinfo = store.getters.state.appdeviceinfo

const Ajax = async (url, data = {}, conf = {}) => {
  let accessToken
  let refreshToken
  let rs
  const { auth = true } = conf
  if (auth) {
    ({ accessToken, refreshToken } = store.getters.state)
    if (refreshToken && !accessToken) {
      accessToken = await store.dispatch('refreshToken', refreshToken)
    }
  }

  if (accessToken ) {
    conf.headers = {
      'Authorization': accessToken,
      ...(conf.headers || {}),
      'Access-Token': accessToken
    }
  }

  instance.defaults.headers.common['Authorization'] = accessToken
  var params = {}
  params['version'] = store.getters.state.version
  params['bundle_id'] = store.getters.state.bundle_id
  params['plat'] = store.getters.state.plat
  params['udid'] = store.getters.state.udid
  params['time'] = Date.parse(new Date()) / 1000
  params['app_key'] = store.getters.state.app_key
  rs = await instance({
    url,
    method: 'post',
    data: {
      ...data,
      ...params,
      sign: sign({...data,...params})
    },
    
    ...conf
  })
  return rs
}

export { baseURL, Ajax, httpRequest, MD5 ,http}
export default Ajax
